import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {HttpParams} from "@angular/common/http";
import {Observable} from "rxjs/index";
import {Pagination} from "@core/bean/pagination";
import {NzModalService} from "ng-zorro-antd";
import {CommonsService} from "@core/service/commons.service";
import {BrowserCommonsService} from "./browser-commons.service";
import {Sort} from "@core/bean/sort";
import {deepCopy} from "@delon/util";
import {Direction} from "@core/bean/direction";

@Component({
  selector: 'app-browser-commons',
  templateUrl: './browser-commons.component.html',
  styles: []
})
export class BrowserCommonsComponent implements OnInit {
  /**
   *接口url
   *  */
  @Input() apiUrl:string;
  /**
   *搜索表单
   * 数组，
   * label:搜索名称，
   * value:搜索的字段
   * type:搜索字段的格式（input（输入框）、dateRange（日期范围）、select（下拉选择框）、dictSelect(字典表)），默认input
   * selectList当选用select时此项为必填，数组对象，例如：[{label:'展示lable1',value:'value1'},{label:'展示lable2',value:'value2'}]
   * dictCode当选用dictSelect时必填，字符串
   **/
  @Input() searchFormList;
  /**
   *表格展示字段
   * label:展示的字段名称，
   * value:字段名
   **/
  @Input() tableFieldList;
  /**
   * 列表title
   * */
  @Input() title:string;
  /**
   * 配置
   * 对象
   * multiple:是否多选，
   * searchData：对象，初始搜索条件，为pagination的搜索条件
   * defaultSort:对象，默认排序字段,例如{sortField:'createdDate',sortOrder:'DESC'},sortOrder值为'DESC','ASC',默认'DESC'
   * */
  @Input() config;
  @Output() private sendData = new EventEmitter();
  public rangeDate:any = {};

  visible = false;
  formLoading = false;
  pagination:Pagination = new Pagination();
  searchData:any = {};
  constructor(private commonsService:CommonsService,
              private modalService:NzModalService,
              private browserCommonsService:BrowserCommonsService
             ) {

  }

  ngOnInit() {
  }
  getData() {
    this.pagination.searchData = this.searchData;
    this.pagination.toFirstPage();
  }
  modalOk() {
    let result = this.pagination.selectedRows;
    if (!(this.config && this.config.multiple)) {
      result = result.length > 0 ? result[0] : null;
      if (result) {
       this.sendData.emit(result);
       this.visible = false;
      } else {
        this.commonsService.showWarningMessage("commons.info.selectData");
      }
    } else {
      if (result.length > 0) {
        this.sendData.emit(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage("commons.info.selectData");
      }
    }
  }

  selectData(data) {
    let result = [data];
    if (!(this.config && this.config.multiple)) {
      result = result.length > 0 ? result[0] : null;
      if (result) {
        this.sendData.emit(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage('commons.info.selectData');
      }
    } else {
      if (result.length > 0) {
        this.sendData.emit(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage('commons.info.selectData');
      }
    }
  }

  modalCancel() {
    this.visible = false;
  }

  initData(){
    let that = this;

    this.pagination.getData = function (params:HttpParams):Observable<any> {
      return that.browserCommonsService.queryData(params,that.apiUrl);
    };

    if(this.config && this.config.searchData){
      this.searchData = deepCopy(this.config.searchData);
    }

    if (!(this.config && this.config.multiple)) {
      this.pagination.multipleCheck = false;
    }
    if(this.config && this.config.defaultSort && this.config.defaultSort.sortField){
      let order;
      if(this.config.defaultSort.sortOrder === 'ASC'){
        order = Direction.ASC;
      }else{
        order = Direction.DESC;
      }
      this.pagination.addDefaultSort(new Sort(this.config.defaultSort.sortField,order));
    }

    this.visible = true;
    this.getData();
  }

//  日期选择框变量变化
  rangeDateChange(item){
    if(this.rangeDate[item['value']]){
      if((this.rangeDate[item['value']])[0]){
        this.searchData[item['value'] + "-ge"] = new Date((this.rangeDate[item['value']])[0].setHours(0, 0, 0, 0));
      }else{
        this.searchData[item['value'] + "-ge"] = null;
      }
      if((this.rangeDate[item['value']])[1]){
        this.searchData[item['value'] + "-le"] = new Date((this.rangeDate[item['value']])[1].setHours(23, 59, 59, 999));
      }else{
        this.searchData[item['value'] + "-le"] = null;
      }
    }else{
      this.searchData[item['value'] + "-ge"] = null;
      this.searchData[item['value'] + "-le"] = null;
    }
  }
}
